import { formatter } from '@uhg-abyss/web/tools/formatter';

export const formatCityStateZip = (address = {}) => {
  const city = formatter('capitalCase', address.city && `${address.city},`);
  const zipCode = address.zipCode || address.zip;
  return [city, address.state, zipCode].filter((n) => n).join(' ');
};
